import React, { useState, useEffect } from "react";

//installed liberaries
import axios from "axios";
import QRCode from "qrcode";
import { useNavigate } from "react-router-dom";
import { PDFDocument } from "pdf-lib";

//css imports
import "./base.css";
import "./questions.css";

// Images Imports
import mobileWireframeFact from "../Assets/Images/Wireframe File Fact.png";
import mobileWireframeLowFact from "../Assets/Images/Wireframe File LowFact.png";

import laptopWireframeFact from "../Assets/Images/LaptopScreens/Blurr fact extreme.png";
import laptopWireframeLowFact from "../Assets/Images/LaptopScreens/Blurr fact low desktop.png";

import tabletWireframeFact from "../Assets/Images/TabletScreens/Blurr fact extreme.png";
import tabletWireframeLowFact from "../Assets/Images/TabletScreens/Blurr fact low desktop.png";

// Audio imports
import { useAudio } from "../Context/AudioContext";

// svg imports
import Image2 from "../Assets/1-02.png";
import Image9 from "../Assets/1-09.png";
import Image10 from "../Assets/1-10.png";
import Image26 from "../Assets/1-26.png";
import { ReactComponent as Image6 } from "../Assets/svg/Beauty, Earth and Planet Elements-06.svg";
import { ReactComponent as Image11 } from "../Assets/svg/Beauty, Earth and Planet Elements-11.svg";
import { ReactComponent as Image12 } from "../Assets/svg/Beauty, Earth and Planet Elements-12.svg";

// components import
import { QRCodePage } from "./qrCode";
import { Bill } from "./Bill";
import { NewCircleButton } from "./nextButton";

// Home component
export const Home = () => {
  const [videoSrc, setVideoSrc] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    // Function to detect screen size and set video link
    const updateVideoSource = () => {
      const screenWidth = window.innerWidth;

      if (screenWidth < 768) {
        // Mobile screen
        setVideoSrc(
          "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beauty%20Bill%20LBP%2FBeauty%20and%20the%20Planet%20Screen%201%20V3%20new%20flower.webm?alt=media&token=6a893666-9f1e-4d89-aedd-d2e5cfbe0803"
        );
      } else if (screenWidth >= 768 && screenWidth < 1024) {
        // Tablet screen
        setVideoSrc(
          "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beautybill%20-%20Version%202%2FSlide%201%20Tab.mp4?alt=media"
        );
      } else {
        // Laptop/Desktop screen
        setVideoSrc(
          "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beauty%20Bill%20LBP%2Fslide%201.mp4?alt=media"
        );
      }
    };

    updateVideoSource();
    window.addEventListener("resize", updateVideoSource);

    return () => {
      window.removeEventListener("resize", updateVideoSource);
    };
  }, []);

  return (
    <div className="main">
      {videoSrc && (
        <video
          className="bg-video"
          width="100%"
          autoPlay
          playsInline
          loop
          muted
        >
          <source src={videoSrc} type="video/mp4" />
          <source src={videoSrc} type="video/webm" />
          Your browser does not support the video tag.
        </video>
      )}
      <div className="next-btn" onClick={() => navigate("/register")}></div>
      {/* next btn */}
      <NewCircleButton
        position="btn-long-absolute"
        onClick={() => navigate("/register")}
      />
      ;
    </div>
  );
};

// Questions component
export const Questions = () => {
  const jsonData = {
    quiz: [
      {
        question: "Your hair care routine includes:",
        answers: ["Shampoo", "Conditioner", "Oil", "Mask", "Serum"],

        // correct: "All",
      },
      {
        question: "For how long have you been following this routine ?",
        answers: ["5-10 years", "10-15 years", "15-25 years"],

        // correct: "< 5 years",
      },
      {
        question: "Do you use a regular sulphates shampoo?",
        answers: ["Yes", "No"],
        // correct: "Shakespeare",
      },
      {
        question: "Are the bottles 100% recycled and recyclable ?",
        answers: ["Yes", "No"],
        // correct: "Au",
      },
      {
        question: "Are the products you used biodegradable ?",
        answers: ["Yes", "No"],
        // correct: "Carbon Dioxide",
      },
    ],
  };

  // get device type
  const getDeviceType = () => {
    const width = window.innerWidth;
    if (width < 768) return "mobile";
    if (width >= 768 && width < 1024) return "tablet";
    return "laptop";
  };

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [extremeCondition, setExtremeConditions] = useState(0);
  const [mediumCondition, setMediumConditions] = useState(0);
  const [lowCondition, setLowConditions] = useState(0);
  const [result, setResult] = useState("Low");
  const [showResult, setShowResult] = useState(false);

  const [selectedAnswerQ0, setSelectedAnswerQ0] = useState([]); // Stores answers for Q0
  const [selectedAnswerQ1, setSelectedAnswerQ1] = useState(""); // Stores answers for Q1
  const [selectedAnswerBool, setSelectedAnswerBool] = useState([]); // Stores answers for Bootlean Q2, Q3, Q4

  const [ImageIndex, setImageIndex] = useState(0);
  const [showBill, setshowBill] = useState(false);
  const [showImpactVal, setShowImpactVal] = useState(null);
  const [imageSrc, setImageSrc] = useState("");
  const [showFacts, setShowFacts] = useState(false);
  const [factContent, setFactContent] = useState(null);
  const [qrCodeUrl, setQrCodeUrl] = useState("");

  const [ImageNextBtnTopValue, setImageNextBtnTopValue] = useState("");

  const navigate = useNavigate();
  let resultType = "Low";
  const [generatedBillUrl, setGeneratedBillUrl] = useState("");

  useEffect(() => {
    console.log("ImageIndex", ImageIndex);
  }, [ImageIndex]);

  // Handle split name
  const splitName = (fullName) => {
    if (!fullName) return { firstName: "", lastName: "" };

    const spaceIndex = fullName.indexOf(" ");
    if (spaceIndex === -1) {
      return { firstName: fullName, lastName: "" };
    }

    return {
      firstName: fullName.substring(0, spaceIndex),
      lastName: fullName.substring(spaceIndex + 1),
    };
  };

  const saveUserResponseMonengage = async (e) => {
    console.log("handleResultsUpdate function : ", ImageIndex);

    if (e && e.preventDefault) {
      e.preventDefault();
    }

    let userData = JSON.parse(localStorage.getItem("user"));

    if (!userData?.firstName || !userData?.lastName || !userData?.email) {
      console.error("User data is missing. Cannot update results.");
      return;
    }

    console.log(showImpactVal.plastic, showImpactVal.carbon, showImpactVal.sulphate, showImpactVal.non_bio);


    try {
      await axios.post(
        `${process.env.REACT_APP_ADMIN}/submitUserResponse`,
        {
          customer_email: userData.email.toLowerCase(),
          firstName: userData.firstName,
          lastName: userData?.lastName,
          result: resultType,
          selectedAnswerQ0: selectedAnswerQ0,
          selectedAnswerQ1: selectedAnswerQ1,
          selectedAnswerBool: selectedAnswerBool,
          Plastic: showImpactVal.plastic,
          CO2: showImpactVal.carbon,
          Sulphate:  showImpactVal.sulphate,
          Non_Biodegradable: showImpactVal.non_bio,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) {
      console.error(
        "Error during results update:",
        error.response?.data?.message || error.message
      );
    }
  };

  // Handle answer for Register
  const handleResultsUpdate = async (e) => {
    console.log("handleResultsUpdate function : ", ImageIndex);

    if (e && e.preventDefault) {
      e.preventDefault();
    }

    let userData = JSON.parse(localStorage.getItem("user"));

    if (!userData?.firstName || !userData?.lastName || !userData?.email) {
      console.error("User data is missing. Cannot update results.");
      return;
    }

    console.log("Update resultType", userData);

    try {
      await axios.post(
        `${process.env.REACT_APP_ADMIN}/saveGeneratedPDF`,
        {
          firstName: userData.firstName,
          lastName: userData?.lastName,
          email: userData.email.toLowerCase(),
          promotionalConsent: userData.isChecked,
          mailConsent: userData.mailConsent,
          result: resultType,
          billPdf: generatedBillUrl,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("Results saved successfully:", response.data);
    } catch (error) {
      console.error(
        "Error during results update:",
        error.response?.data?.message || error.message
      );
    }
  };

  //Handle Next button
  const handleNext = async () => {
    if (currentQuestionIndex === 0 && selectedAnswerQ0.length === 0) {
      alert("Please select at least one answer before proceeding.");
      return;
    }

    if (currentQuestionIndex > 0 && !selectedAnswer) {
      alert("Please select an answer before proceeding.");
      return;
    }

    // console.log(`Current Question Index: ${currentQuestionIndex}`);
    const nextIndex = currentQuestionIndex;

    if (currentQuestionIndex === 1) {
      setSelectedAnswerQ1(selectedAnswer); // Store single answer for Q1
      // console.log("Selected Answer for Q1:", selectedAnswer);
    }

    // Move to the next question
    setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
    setSelectedAnswer(null);

    let boolAnswer;

    switch (nextIndex) {
      case 0:
        setExtremeConditions((prev) => prev + 1);
        setMediumConditions((prev) => prev + 1);
        setLowConditions((prev) => prev + 1);

        break;

      case 1:
        if (selectedAnswer === "15-25 years") {
          setExtremeConditions((prev) => prev + 1);
        } else if (selectedAnswer === "10-15 years") {
          setMediumConditions((prev) => prev + 1);
        } else if (selectedAnswer === "5-10 years") {
          setLowConditions((prev) => prev + 1);
        }
        setSelectedAnswerQ1(selectedAnswer);

        break;

      case 2:
        if (selectedAnswer === "Yes") {
          boolAnswer = true;
          setExtremeConditions((prev) => prev + 1);
        } else if (selectedAnswer === "No") {
          boolAnswer = false;
          setMediumConditions((prev) => prev + 1);
          setLowConditions((prev) => prev + 1);
        }
        setSelectedAnswerBool((prev) => [...prev, boolAnswer]);
        break;

      case 3:
      case 4:
        if (selectedAnswer === "Yes") {
          boolAnswer = true;
          setLowConditions((prev) => prev + 1);
        } else if (selectedAnswer === "No") {
          boolAnswer = false;
          setMediumConditions((prev) => prev + 1);
          setExtremeConditions((prev) => prev + 1);
        }
        setSelectedAnswerBool((prev) => [...prev, boolAnswer]);
        break;

      default:
        break;
    }

    if (currentQuestionIndex < jsonData.quiz.length - 1) {
      setCurrentQuestionIndex(nextIndex + 1);
      setSelectedAnswer(null); // Reset selection for the next question
    } else {
      const result = {
        extreme: extremeCondition,
        medium: mediumCondition,
        low: lowCondition,
      };

      // console.log("Final Values:", result);
      if (
        extremeCondition > mediumCondition &&
        extremeCondition > lowCondition
      ) {
        resultType = "Extreme";
      } else if (
        mediumCondition > extremeCondition &&
        mediumCondition > lowCondition
      ) {
        resultType = "Medium";
      } else if (
        lowCondition > extremeCondition &&
        lowCondition > mediumCondition
      ) {
        resultType = "Low";
      } else {
        // **Handling Equal Cases with Priority Order: Extreme > Medium > Low**
        if (
          extremeCondition === mediumCondition &&
          extremeCondition > lowCondition
        ) {
          resultType = "Extreme";
        } else if (
          extremeCondition === lowCondition &&
          extremeCondition > mediumCondition
        ) {
          resultType = "Extreme";
        } else if (
          mediumCondition === lowCondition &&
          mediumCondition > extremeCondition
        ) {
          resultType = "Medium";
        } else {
          resultType = "Extreme"; // If all are equal, give priority to Extreme
        }
      }

      // console.log("Final Condition:", result);
      setResult(resultType);
      setShowResult(!showResult);
    }
  };

  const currentQuestion = jsonData.quiz[currentQuestionIndex];

  const Images = {
    Extreme: {
      mobile: [
        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beauty%20Bill%20LBP%2FGirl%20with%20White%20eye%20screen%20V1.mp4?alt=media&token=2df690f6-74e0-40ff-9256-bb712255f76b",

        //no use--
        "1",
        "2",
        "3",
        "4",
        "5",
        // no use --

        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beauty%20Bill%20LBP%2FBeaut%20and%20bill%20delivred%20screen%20V2.mp4?alt=media",

        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beauty%20Bill%20LBP%2Fbunny%20picture%20screen%20V2.mp4?alt=media",
        generatedBillUrl,
      ],
      tablet: [
        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beautybill%20-%20Version%202%2FSlide%2011%20Tab%20.mp4?alt=media",

        //no use--
        "1",
        "2",
        "3",
        "4",
        "5",
        // no use --

        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beautybill%20-%20Version%202%2FSlide%204%20Tab%20.mp4?alt=media",

        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beautybill%20-%20Version%202%2FSlide%2010%20Tab.mp4?alt=media",
        generatedBillUrl,
      ],
      laptop: [
        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beauty%20Bill%20LBP%2FSlide%207.mp4?alt=media",

        //no use--
        "1",
        "2",
        "3",
        "4",
        "5",
        // no use --

        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beauty%20Bill%20LBP%2FSlide%203.mp4?alt=media",

        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beauty%20Bill%20LBP%2FSlide%205.mp4?alt=media",
        generatedBillUrl,
      ],
    },
    Medium: {
      mobile: [
        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beauty%20Bill%20LBP%2FGirl%20with%20White%20eye%20screen%20V1.mp4?alt=media&token=2df690f6-74e0-40ff-9256-bb712255f76b",

        //no use--
        "1",
        "2",
        "3",
        "4",
        "5",
        // no use --

        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beauty%20Bill%20LBP%2FBeaut%20and%20bill%20delivred%20screen%20V2.mp4?alt=media",

        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beauty%20Bill%20LBP%2Fbunny%20picture%20screen%20V2.mp4?alt=media",
        generatedBillUrl,
      ],
      tablet: [
        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beautybill%20-%20Version%202%2FSlide%2012%20Tab.mp4?alt=media",

        //no use--
        "1",
        "2",
        "3",
        "4",
        "5",
        // no use --

        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beautybill%20-%20Version%202%2FSlide%204%20Tab%20.mp4?alt=media",

        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beautybill%20-%20Version%202%2FSlide%2010%20Tab.mp4?alt=media",
        generatedBillUrl,
      ],
      laptop: [
        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beauty%20Bill%20LBP%2FSlide%208.mp4?alt=media",

        //no use--
        "1",
        "2",
        "3",
        "4",
        "5",
        // no use --

        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beauty%20Bill%20LBP%2FSlide%203.mp4?alt=media",

        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beauty%20Bill%20LBP%2FSlide%205.mp4?alt=media",
        generatedBillUrl,
      ],
    },
    Low: {
      mobile: [
        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beauty%20Bill%20LBP%2FGirl%20with%20White%20eye%20screen%20V1.mp4?alt=media&token=2df690f6-74e0-40ff-9256-bb712255f76b",

        //no use--
        "1",
        "2",
        "3",
        "4",
        "5",
        // no use --

        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beauty%20Bill%20LBP%2FBeaut%20and%20bill%20delivred%20screen%20V2.mp4?alt=media",

        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beauty%20Bill%20LBP%2Fbunny%20picture%20screen%20V2.mp4?alt=media",
        generatedBillUrl,
      ],
      tablet: [
        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beautybill%20-%20Version%202%2FSlide%2013%20Tab.mp4?alt=media",

        //no use--
        "1",
        "2",
        "3",
        "4",
        "5",
        // no use --

        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beautybill%20-%20Version%202%2FSlide%204%20Tab%20.mp4?alt=media",

        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beautybill%20-%20Version%202%2FSlide%2010%20Tab.mp4?alt=media",
        generatedBillUrl,
      ],
      laptop: [
        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beauty%20Bill%20LBP%2FSlide%209.mp4?alt=media",

        //no use--
        "1",
        "2",
        "3",
        "4",
        "5",
        // no use --

        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beauty%20Bill%20LBP%2FSlide%203.mp4?alt=media",

        "https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Beauty%20Bill%20LBP%2FSlide%205.mp4?alt=media",
        generatedBillUrl,
      ],
    },
  };

  // Handle Emition Calculation
  const handleEmitionCalculation = (selectedAnswerQ0, selectedAnswerQ1) => {
    const emissionValues = {
      "5-10 years": {
        carbon: 15.05,
        plastic: 805,
        sulphate: 4970,
        non_bio: 1206,

        carbon_oil: 4.3,
        carbon_mask: 8.6,
        carbon_serum: 4.3,

        plastic_oil: 230,
        plastic_mask: 580,
        plastic_serum: 75,

        sulphate_oil: 1420,
        sulphate_mask: 2840,
        sulphate_serum: 1420,

        non_bio_oil: 344.6,
        non_bio_mask: 689.2,
        non_bio_serum: 344.6,
      },
      "10-15 years": {
        carbon: 30.1,
        plastic: 1610,
        sulphate: 9940,
        non_bio: 2412.2,

        carbon_oil: 8.6,
        carbon_mask: 17.2,
        carbon_serum: 8.6,

        plastic_oil: 460,
        plastic_mask: 1160,
        plastic_serum: 150,

        sulphate_oil: 2840,
        sulphate_mask: 5680,
        sulphate_serum: 2840,

        non_bio_oil: 689.2,
        non_bio_mask: 1378.4,
        non_bio_serum: 689.2,
      },
      "15-25 years": {
        carbon: 45.15,
        plastic: 2415,
        sulphate: 14910,
        non_bio: 3618.3,

        carbon_oil: 12.9,
        carbon_mask: 25.8,
        carbon_serum: 12.9,

        plastic_oil: 690,
        plastic_mask: 1740,
        plastic_serum: 225,

        sulphate_oil: 4260,
        sulphate_mask: 8520,
        sulphate_serum: 4260,

        non_bio_oil: 1033.8,
        non_bio_mask: 2067.6,
        non_bio_serum: 1033.8,
      },
    };

    // Ensure selectedAnswerQ1 is a valid category
    if (!emissionValues[selectedAnswerQ1]) {
      console.log("selectedAnswerQ1 is empty");
      return;
    }

    // Fetch the appropriate emission values based on selectedAnswerQ1
    const {
      carbon,
      plastic,
      sulphate,
      non_bio,
      carbon_oil,
      carbon_mask,
      carbon_serum,

      plastic_oil,
      plastic_mask,
      plastic_serum,

      sulphate_oil,
      sulphate_mask,
      sulphate_serum,

      non_bio_oil,
      non_bio_mask,
      non_bio_serum,
    } = emissionValues[selectedAnswerQ1];

    // Initialize impact values
    let totalImpact = { plastic: 0, carbon: 0, sulphate: 0, non_bio: 0 };

    // Define multipliers
    const multipliers = {
      Shampoo: {
        carbon: carbon,
        plastic: plastic,
        sulphate: sulphate,
        non_bio: non_bio,
      },
      Conditioner: {
        carbon: carbon,
        plastic: plastic,
        sulphate: sulphate,
        non_bio: non_bio,
      },
      Oil: {
        carbon: carbon_oil,
        plastic: plastic_oil,
        sulphate: sulphate_oil,
        non_bio: non_bio_oil,
      },
      Mask: {
        carbon: carbon_mask,
        plastic: plastic_mask,
        sulphate: sulphate_mask,
        non_bio: non_bio_mask,
      },
      Serum: {
        carbon: carbon_serum,
        plastic: plastic_serum,
        sulphate: sulphate_serum,
        non_bio: non_bio_serum,
      },
    };

    // Calculate total impact
    selectedAnswerQ0.forEach((item) => {
      if (multipliers[item]) {
        totalImpact.carbon += carbon;
        totalImpact.sulphate += sulphate;
        totalImpact.non_bio += non_bio;

        // Add plastic impact for Oil & Mask, but don't multiply for others
        if (item === "Oil" || item === "Mask") {
          totalImpact.plastic += multipliers[item].plastic;
        } else {
          totalImpact.plastic += plastic;
        }
      }
    });
    setShowImpactVal(totalImpact);
    return totalImpact;
  };

  // Handle PDF Generation and Upload
  const modifyAndUploadPDF = async () => {
    try {
      const imageUrl = "/Assets/billmob.png";
      const response = await fetch(imageUrl);

      if (!response.ok) {
        throw new Error(
          `Failed to fetch Image: ${response.status} ${response.statusText}`
        );
      }

      const blob = await response.blob();

      const img = await createImageBitmap(blob);

      console.log("image size-w", img.width, "height", img.height);
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);

      ctx.font = "30px Arial";
      ctx.fillStyle = "black";
      ctx.fillText(
        `${Number(showImpactVal?.plastic).toFixed(2)}g`,
        img.width - 290,
        img.height - 1000
      );
      ctx.fillText(
        `${Number(showImpactVal?.carbon).toFixed(2)}kg`,
        img.width - 290,
        img.height - 910
      );
      ctx.fillText(
        `${Number(showImpactVal?.sulphate).toFixed(2)}g`,
        img.width - 290,
        img.height - 830
      );
      ctx.fillText(
        `${Number(showImpactVal?.non_bio).toFixed(2)}g`,
        img.width - 290,
        img.height - 730
      );

      const modifiedBlob = await new Promise(
        (resolve) => canvas.toBlob(resolve, "image/png", 0.95) // Uses Blob instead of Base64 to save memory
      );

      const pdfDoc = await PDFDocument.create();
      const page = pdfDoc.addPage([img.width, img.height]);

      const imageBytes = await modifiedBlob.arrayBuffer();
      const embeddedImage = await pdfDoc.embedPng(imageBytes);
      page.drawImage(embeddedImage, {
        x: 0,
        y: 0,
        width: img.width,
        height: img.height,
      });

      const modifiedPdfBytes = await pdfDoc.save();

      const pdfBlob = new Blob([modifiedPdfBytes], { type: "application/pdf" });

      const pdfFile = new File([pdfBlob], "GeneratedBill.pdf", {
        type: "application/pdf",
      });

      if (window.uploadActivity) {
        console.log("Uploading PDF...");
        const generatedQr = await window.uploadActivity(pdfFile);

        if (generatedQr) {
          setGeneratedBillUrl(generatedQr);
          await handleGenerateQR(generatedQr);
          console.log("Generated QR: ", generatedQr);
        } else {
          console.error("Error: PDF upload failed, no URL received.");
        }
      } else {
        console.error("uploadActivity function is not available.");
      }
    } catch (error) {
      console.error("Error modifying or uploading Image as PDF:", error);
    }
  };

  // Handle QR Code Generation
  const handleGenerateQR = async (Data) => {
    if (!Data) {
      console.error("Error: Data is undefined or empty!");
      return;
    }

    try {
      const qrCode = await QRCode.toDataURL(Data, {
        color: {
          dark: "#3BB80D", // Green QR code color
          light: "#FFFFFF", // White background
        },
      });

      setQrCodeUrl(qrCode);
    } catch (error) {
      console.error("QR Code Generation Error:", error);
    }
  };

  // Handle Image Generation based on device type and result
  const handleFactImageGeneration = (result) => {
    const screenWidth = window.innerWidth;

    if (screenWidth < 768) {
      // Mobile screen
      return result === "Low" ? mobileWireframeLowFact : mobileWireframeFact;
    } else if (screenWidth >= 768 && screenWidth < 1024) {
      // Tablet screen
      return result === "Low" ? tabletWireframeLowFact : tabletWireframeFact;
    } else {
      // Laptop/Desktop screen
      return result === "Low" ? laptopWireframeLowFact : laptopWireframeFact;
    }
  };

  // Handle Image Generation based on device type and result
  const getImage = async (result, index) => {
    const deviceType = getDeviceType();

    if (index === 1) {
      handleEmitionCalculation(selectedAnswerQ0, selectedAnswerQ1);
    }

    if ([2, 3, 4, 5].includes(index)) {
      // return;
      return handleFactImageGeneration(result);
    }

    return (
      Images[result]?.[deviceType]?.[index] ||
      Images["Low"]?.[deviceType]?.[index]
    );
  };

  // Fact Values Component
  const FactValues = ({ result, ImageIndex }) => {
    if (!showImpactVal) return null;

    const factsData = {
      high: {
        2: [
          `Oops, looks like you’ve generated  ${Number(
            showImpactVal?.plastic
          ).toFixed(2)} grams of plastic waste ☹️`,
          "It takes over 450 years to break down a plastic shampoo bottle. Make the move to Recycled!",
        ],
        3: [
          `${Number(showImpactVal?.carbon).toFixed(2)} kg CO₂ emission`,
          "Everything ultimately ends up in the ocean and are invisible invaders that fish and aquatic animals unknowingly ingest. Cruel, right? Let’s go cruelty-free!",
        ],
        4: [
          `${Number(showImpactVal?.sulphate).toFixed(
            2
          )} grams of sulphates created.`,
          "Unless your hair has industrial grease, you don’t need sulphates in your shampoo!",
        ],
        5: [
          `${Number(showImpactVal?.non_bio).toFixed(
            2
          )} grams of non-biodegradable waste generated`,
          "Today’s trend ends up in tomorrow’s landfill. Don’t let our planet pay the price for these non-biodegradable choices. Let’s choose better!",
        ],
      },
      low: {
        2: ["Queen, look at you go. May your tribe prosper."],
        3: ["Girl, you're goals. You're making such a difference 💖"],
        4: [
          "You're not just living, you're thriving. Congratulations on your score.",
        ],
        5: ["Leading by example. That's an outstanding score."],
      },
    };

    const impactLevel = result?.toLowerCase() === "low" ? "low" : "high";
    const messages = factsData[impactLevel]?.[ImageIndex] || [];

    // console.log("Impact Level:", impactLevel, "Messages:", messages);

    return messages.length > 0 ? (
      <div className={`fact-message-container`}>
        <div className="fact-btn">
          <NewCircleButton
            position="btn-long-relative"
            onClick={() => {
              if (ImageIndex === 4) handleResultsUpdate();
              if (ImageIndex === 3) {
                console.log("ImageIndex ===3", saveUserResponseMonengage);
                //save result in moengage
                saveUserResponseMonengage();
              }
              setImageIndex((prevIndex) => prevIndex + 1);
            }}
          />
        </div>

        {messages[1] && (
          <div className="fast-top-cont fact-cont">
            <div className="fact-head-icon fact-image-one ">
              <img id="earth-img" src={Image10} alt="image9"></img>
            </div>
            <p>{messages[1]}</p>
          </div>
        )}

        <div className="fast-bottom-cont fact-cont">
          <div className="fact-head-icon fact-image-two ">
            <img id="recycle-img" src={Image9} alt="image9"></img>
            <Image11 className="svgIcon svgHidden" />
          </div>
          <p>{messages[0]}</p>
        </div>
      </div>
    ) : null;
  };

  // Handle Images, Facts based on results and ImageIndex
  useEffect(() => {
    if (result === undefined || ImageIndex === undefined) return;

    setshowBill(ImageIndex === 1);
    if (ImageIndex === 2) {
      modifyAndUploadPDF();
    }

    setShowFacts([2, 3, 4, 5].includes(ImageIndex));

    setFactContent(<FactValues result={result} ImageIndex={ImageIndex} />);

    const fetchImage = async () => {
      try {
        const img = await getImage(result, ImageIndex);
        // console.log("Image:", img);
        setImageSrc(img);
      } catch (error) {
        console.error("Error fetching image:", error);
      }
    };

    fetchImage();
  }, [result, ImageIndex]);

  // for positioning Image-next-btn for each image and screen size
  useEffect(() => {
    const updateTopValue = () => {
      const screenWidth = window.innerWidth;

      let newTopValue = "1%";

      if (screenWidth < 768) {
        // Mobile
        newTopValue =
          ImageIndex === 0
            ? "75%"
            : ImageIndex === 1
            ? "75%"
            : ImageIndex === 2
            ? "75%"
            : ImageIndex === 3
            ? "75%"
            : ImageIndex === 4
            ? "75%"
            : ImageIndex === 5
            ? "75%"
            : ImageIndex === 6
            ? "75%"
            : ImageIndex === 7
            ? "75%"
            : ImageIndex === 8
            ? "75%"
            : newTopValue;
      } else if (screenWidth >= 768 && screenWidth < 1024) {
        // Tablet
        newTopValue =
          ImageIndex === 0
            ? "75%"
            : ImageIndex === 1
            ? "75%"
            : ImageIndex === 2
            ? "75%"
            : ImageIndex === 3
            ? "75%"
            : ImageIndex === 4
            ? "75%"
            : ImageIndex === 5
            ? "75%"
            : ImageIndex === 6
            ? "72%"
            : ImageIndex === 7
            ? "75%"
            : ImageIndex === 8
            ? "72%"
            : newTopValue;
      } else {
        // Laptop/Desktop
        newTopValue =
          ImageIndex === 0
            ? "71%"
            : ImageIndex === 1
            ? "71%"
            : ImageIndex === 2
            ? "75%"
            : ImageIndex === 3
            ? "75%"
            : ImageIndex === 4
            ? "75%"
            : ImageIndex === 5
            ? "75%"
            : ImageIndex === 6
            ? "68%"
            : ImageIndex === 7
            ? "70%"
            : ImageIndex === 8
            ? "70%"
            : newTopValue;
      }

      setImageNextBtnTopValue(newTopValue);
    };

    updateTopValue();
    window.addEventListener("resize", updateTopValue);

    return () => {
      window.removeEventListener("resize", updateTopValue);
    };
  }, [ImageIndex]);

  const { setIsPlaying } = useAudio();

  return (
    <div className="main">
      {showResult ? (
        <>
          {/* Image / video */}
          {ImageIndex !== 1 &&
          ImageIndex !== 2 &&
          ImageIndex !== 3 &&
          ImageIndex !== 4 &&
          ImageIndex !== 5 &&
          ImageIndex !== 8 &&
          imageSrc.includes("firebase") ? (
            <video
              key={imageSrc}
              className="bg-video"
              width="100%"
              autoPlay
              playsInline
              loop
              muted
            >
              <source src={imageSrc} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            ImageIndex !== 1 &&
            ImageIndex !== 2 &&
            ImageIndex !== 3 &&
            ImageIndex !== 4 &&
            ImageIndex !== 5 &&
            ImageIndex !== 8 && <img src={imageSrc} width="100%" alt="Result" />
          )}

          {/* Bill */}
          {showBill && Object.keys(showImpactVal).length !== 0 && (
            <Bill
              showImpactVal={showImpactVal}
              button={() => setImageIndex((prevIndex) => prevIndex + 1)}
            />
          )}

          {/* Fact messages */}
          {showFacts && factContent}

          {/* QR code page */}
          {ImageIndex === 8 && (
            <QRCodePage qrCodeUrl={qrCodeUrl} pdfUrl={generatedBillUrl} onClick={() => navigate("/")} />
          )}
          {/* Next button */}
          <NewCircleButton
            position="btn-long-absolute"
            slideIndex={ImageIndex}
            onClick={() => {
              if (ImageIndex === 0) setIsPlaying(true);
              setImageIndex((prevIndex) => prevIndex + 1);
            }}
          />
        </>
      ) : (
        <>
          {/* Start the quiz */}
          <div className="new-questions-container" key={currentQuestionIndex}>
            {/* heading */}
            <div className="question-heading-cont">
              <div className="q-head-box">
                <h1>Question {currentQuestionIndex + 1}</h1>
              </div>
              <div className="q-head-icon">
                <Image6 className="svgIcon " />
              </div>
            </div>
            {/* dotted line */}
            <div className="dashed-line">
              <img src={Image2} className="star" alt="star"></img>
            </div>
            {/* question / answer container */}
            <div className="question-cont">
              {/* Images */}
              <div className="q-head-icon image-one ">
                <Image11 className="svgIcon" />
              </div>
              <div className="q-head-icon image-two ">
                <Image12 className="svgIcon" />
              </div>

              {/* question */}
              <div className="question-box">
                <h2>{currentQuestion.question}</h2>
              </div>

              {/* answer options */}
              <div className="options-cont">
                {currentQuestion.answers.map((answer, index) => (
                  <div
                    className={`options ${
                      currentQuestionIndex === 0
                        ? selectedAnswerQ0.includes(answer)
                          ? "selected"
                          : ""
                        : selectedAnswer === answer
                        ? "selected"
                        : ""
                    }`}
                    key={index}
                    onClick={() => {
                      if (currentQuestionIndex === 0) {
                        setSelectedAnswerQ0((prevSelected) =>
                          prevSelected.includes(answer)
                            ? prevSelected.filter((ans) => ans !== answer)
                            : [...prevSelected, answer]
                        );
                      } else {
                        setSelectedAnswer(answer);
                      }
                    }}
                    style={{ animationDelay: `${index * 0.5}s` }}
                  >
                    {answer}
                  </div>
                ))}
              </div>
            </div>
            {/* next button */}
            <NewCircleButton
              position="btn-long-relative"
              onClick={handleNext}
            />
            <div className="footer-container question-footer">
              <img src={Image26} className="page-footer" alt="footer"></img>
            </div>{" "}
          </div>
        </>
      )}
    </div>
  );
};
